export default __webpack_public_path__ + "static/media/blog-edge-patio-001.16cc7aa0.jpeg";